import { isNullOrEmpty } from "./util.ts";
import { AdoptablePetDetailWrapper } from "./AdoptablePetDetailPage.tsx";
import { AdoptedPetDetailWrapper } from "./AdoptedPetDetailPage.tsx";

type PetDetailProps = {
  petId?: string;
  adoptionId?: string;
};

/** works for either adopted or adoptable pet */
export default function PetDetail({ petId, adoptionId }: PetDetailProps) {
  if (!isNullOrEmpty(petId)) {
    return <AdoptablePetDetailWrapper petId={petId} />;
  }
  if (!isNullOrEmpty(adoptionId)) {
    return <AdoptedPetDetailWrapper adoptionId={adoptionId} />;
  }
}
